// TODO: this should be a capability
import Bowser from "bowser";
const bowser = Bowser.getParser(window.navigator.userAgent);
export const tempEnvConfig = {
    userAgent: {
        device: { name: bowser.getPlatformType() },
        name: bowser.getBrowserName(),
        version: bowser.getBrowserVersion(),
    },
    hostname: window.location.hostname,
};
